// extracted by mini-css-extract-plugin
module.exports = {"bg":"ColorBackground-module__fvLmjW__bg"};